import React, { useState } from 'react'
import { useAuth } from './AuthContext'
import { supabase } from '../lib/supabase'
import PasswordInput from '../components/ui/PasswordInput'

export default function SetupFromLinkScreen({ token }) {
  const { signIn } = useAuth()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    if (password.length < 6) { setError('Password must be at least 6 characters'); return }
    if (password !== confirm) { setError('Passwords do not match'); return }
    setLoading(true)
    try {
      console.log('[Setup] Calling /api/complete-setup with token:', token.substring(0, 8) + '...')
      const resp = await fetch('/api/complete-setup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      })
      const result = await resp.json()
      console.log('[Setup] API response:', resp.status, JSON.stringify(result))

      if (!resp.ok) {
        setError(result.error || 'Setup failed')
        setLoading(false)
        return
      }

      // Clean the token from the URL so it can't be re-used/bookmarked
      window.history.replaceState({}, '', window.location.pathname)

      // Prefer server-provided session (avoids race condition), fall back to signInWithPassword
      if (result.session && result.session.access_token) {
        console.log('[Setup] Using server-provided session for:', result.email)
        await supabase.auth.setSession({
          access_token: result.session.access_token,
          refresh_token: result.session.refresh_token,
        })
      } else {
        console.log('[Setup] No session in response, falling back to signInWithPassword for:', result.email)
        await signIn(result.email, password)
      }
    } catch (err) {
      console.error('[Setup] Error:', err)
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white tracking-wide">BEATY</h1>
          <p className="text-slate-400 mt-1">Brothers Moving System</p>
        </div>
        <div className="bg-white rounded-xl shadow-xl p-8">
          <div className="text-center mb-6">
            <h2 className="text-xl font-bold text-slate-900">Welcome!</h2>
            <p className="text-sm text-slate-500 mt-1">Create a password to finish setting up your account.</p>
          </div>
          {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-sm font-medium text-slate-700 mb-1">Create Password</label>
              <PasswordInput required minLength="6" value={password} onChange={e => setPassword(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent" placeholder="Min 6 characters" autoFocus />
            </div>
            <div className="mb-6">
              <label className="block text-sm font-medium text-slate-700 mb-1">Confirm Password</label>
              <PasswordInput required minLength="6" value={confirm} onChange={e => setConfirm(e.target.value)} className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent" placeholder="Re-enter password" />
            </div>
            <button type="submit" disabled={loading} className="w-full bg-red-600 hover:bg-red-700 text-white py-2.5 rounded-lg text-sm font-medium disabled:opacity-50">
              {loading ? 'Setting up...' : 'Set Password & Sign In'}
            </button>
          </form>
        </div>
        <p className="text-center text-slate-500 text-xs mt-6">Beaty Brothers Moving • Nashville, TN</p>
      </div>
    </div>
  )
}
